import { CapoPlugin } from "/app/node_modules/.pnpm/@unhead+vue@1.11.6_vue@3.5.8_typescript@5.6.2_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];